<template>
	<div class="flex mobileFlex">
		<ValidationProvider
			class="inputBox infoBox wd50"
			name="시도"
			rules="required"
			v-slot="{ errors }"
		>
			<label>시도<span class="labelItem">*</span></label>
			<div class="bspSelectBox">
				<b-form-select
					v-model="selectedSido"
					:options="sidoList"
					@change="getAddressDetailList(selectedSido)"
				></b-form-select>
			</div>
			<span class="notValidationTxt">{{ errors[0] }}</span>
		</ValidationProvider>
		<ValidationProvider
			class="inputBox infoBox wd50"
			name="시군구"
			rules="required"
			v-slot="{ errors }"
		>
			<label>시군구<span class="labelItem">*</span></label>
			<div class="bspSelectBox">
				<b-form-select
					v-model="selectedSigungu"
					:options="sigunguList"
					@change="setAddress"
				></b-form-select>
			</div>
			<span class="notValidationTxt">{{ errors[0] }}</span>
		</ValidationProvider>
	</div>
</template>
<script>
import { mapActions } from 'vuex'
import { ValidationProvider } from 'vee-validate'

export default {
	components: {
		ValidationProvider,
	},
	props: ['signupInfo', 'childDataLoaded', 'defaultSido', 'defaultSigungu'],
	data() {
		return {
			selectedSido: this.defaultSido || '',
			sidoList: [],
			selectedSigungu: this.defaultSigungu || '',
			sigunguList: [],
		}
	},
	watch: {
		defaultSido(val) {
			this.selectedSido = val
		},
		defaultSigungu(val) {
			this.selectedSigungu = val
		},
	},
	mounted() {
		this.loadAddress()
	},
	methods: {
		...mapActions('address', ['requestAddressList', 'requestAddressDetailList']),
		loadAddress() {
			this.requestAddressList()
				.then((response) => {
					let addressList = response.data
					this.sidoList = []

					this.sidoList.push({ value: '', text: '선택' })
					this.selectedSido = ''
					for (let i = 0; i < addressList.length; i++) {
						let value = addressList[i].admCode
						let text = addressList[i].lowestAdmCodeNm
						let addressMap = { value: value, text: text }

						this.sidoList.push(addressMap)
						if (value == this.signupInfo.categoryTargetIdx) {
							this.selectedSido = value
						}
					}

					if (this.selectedSido) {
						this.getAddressDetailList(this.selectedSido)
					} else {
						this.sigunguList.push({ value: '', text: '선택' })
					}
				})
				.catch(() => {
					this.$alert('알림', '시도 주소를 가져올 수 없습니다.')
				})
		},
		getAddressDetailList(admCode) {
			this.sigunguList = []

			this.requestAddressDetailList(admCode)
				.then((response) => {
					let addressList = response.data

					this.sigunguList.push({ value: '', text: '선택' })
					this.selectedSigungu = ''
					for (let i = 0; i < addressList.length; i++) {
						let value = addressList[i].admCode
						let text = addressList[i].lowestAdmCodeNm
						let addressMap = { value: value, text: text }

						this.sigunguList.push(addressMap)

						if (value == this.signupInfo.city) {
							this.selectedSigungu = value
						}
					}
				})
				.catch(() => {
					this.$alert('알림', '시군구 주소를 가져올 수 없습니다.')
				})
		},
		setAddress() {
			let address = ''
			let addressDetail = ''
			let addressId = 0
			let addressDetailId = 0
			for (let i in this.sidoList) {
				if (this.selectedSido == this.sidoList[i].value) {
					address = this.sidoList[i].text
					addressId = this.sidoList[i].value
				}
			}
			for (let i in this.sigunguList) {
				if (this.selectedSigungu == this.sigunguList[i].value) {
					addressDetail = this.sigunguList[i].text
					addressDetailId = this.sigunguList[i].value
				}
			}

			this.$emit('set-address', address, addressDetail, addressId, addressDetailId)
		},
	},
}
</script>
